import { render, staticRenderFns } from "./tongjis.vue?vue&type=template&id=ec698368&scoped=true&"
import script from "./tongjis.vue?vue&type=script&lang=js&"
export * from "./tongjis.vue?vue&type=script&lang=js&"
import style0 from "./tongjis.vue?vue&type=style&index=0&id=ec698368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec698368",
  null
  
)

export default component.exports